export default __webpack_public_path__ + "static/media/boho.66ab0cb2.jpeg";